import mergeClasses from '../../../utils/shallowMerge';
import { Heading } from '../../typography/heading/Heading';
import Title from '../../typography/title/index';
import { StylesCustomizer } from '../stylesCustomizer';
import defaultClasses from './DescriptionSection.module.scss';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { markdown } from 'markdown';

const DescriptionSection = ({ title = '', description = '', placement, customClasses, descriptionStyles }) => {
  const styles = mergeClasses(defaultClasses, customClasses);

  const html = useMemo(() => markdown.toHTML(description || ''), [description]);

  const DescriptionText = (variables) => {
    return (
      <div
        style={{ ...variables }}
        dangerouslySetInnerHTML={{
          __html: html,
        }}
      />
    );
  };

  const StyledDescriptionText = StylesCustomizer(DescriptionText);

  return (
    <div
      className={clsx(styles.root, {
        [styles.rootOnCmsPages]: placement === 'cmsPages' && placement,
      })}
    >
      <div className={styles.titleWrapper}>
        <Title>
          {title && (
            <Heading as="h2" textTransform="uppercase" weight="light">
              {title}
            </Heading>
          )}
          {description && <StyledDescriptionText styles={descriptionStyles} />}
        </Title>
      </div>
    </div>
  );
};

DescriptionSection.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

export default DescriptionSection;
